import {createPopper} from '@popperjs/core';

const debouncedSearch = debounce(search, 300)

$(document).ready(function () {
    // Function to validate phone number format
    function validatePhoneNumberField(inputField) {
        inputField = $(inputField);
        let phoneRegex = /^(\+\d{1,3})?\d{8,}$/;
        let labelContainer = inputField.siblings('.label-container');
        let errorField = labelContainer.children('.error-message');
        let errorMessage = null;

        if (!inputField.val() && inputField.hasClass('required-field')) {
            errorMessage = translations.fieldRequired;
        }

        if (inputField.val() && !phoneRegex.test(inputField.val().replace(/\s/g, ''))) {
            errorMessage = translations.invalidPhone;
        }

        if (errorMessage) {
            inputField.addClass('is-invalid');
            if (!errorField.length) {
                $(`<span class="error-message">${errorMessage}</span>`).appendTo(labelContainer);
            } else {
                errorField.text(errorMessage);
            }

            return false;
        }

        inputField.removeClass('is-invalid');
        errorField.remove();
        return true;
    }

    // Function to validate email format
    function validateEmailField(inputField) {
        inputField = $(inputField);
        let emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        let labelContainer = inputField.siblings('.label-container');
        let errorField = labelContainer.children('.error-message');
        let errorMessage = null;

        if (!inputField.val() && inputField.hasClass('required-field')) {
            errorMessage = translations.fieldRequired;
        }

        if (inputField.val() && !emailRegex.test(inputField.val())) {
            errorMessage = translations.invalidEmail;
        }

        if (errorMessage) {
            inputField.addClass('is-invalid');
            if (!errorField.length) {
                $(`<span class="error-message">${errorMessage}</span>`).appendTo(labelContainer);
            } else {
                errorField.text(errorMessage);
            }

            return false;
        }

        inputField.removeClass('is-invalid');
        errorField.remove();
        return true;
    }

    function validateRequiredField(inputField) {
        inputField = $(inputField);
        let labelContainer = inputField.siblings('.label-container');
        let errorField = labelContainer.children('.error-message');
        if (inputField.val().trim() === '') {
            inputField.addClass('is-invalid');
            if (!errorField.length) {
                $(`<span class="error-message">${translations.fieldRequired}</span>`).appendTo(labelContainer);
            }

            return false;
        }

        inputField.removeClass('is-invalid');
        errorField.remove();
        return true;
    }

    // Validate fields on blur
    $(document).on('blur', '.phone-input', function () {
        validatePhoneNumberField($(this));
    });

    $(document).on('blur', '.email-input', function () {
        validateEmailField($(this));
    });

    $(document).on('blur', '.required-field:not(.phone-input):not(.email-input)', function () {
        validateRequiredField(this);
    });

    // Validate fields on input when already invalid
    $(document).on('input', '.phone-input', function () {
        if ($(this).hasClass('is-invalid')) {
            validatePhoneNumberField(this);
        }
    });

    $(document).on('input', '.email-input', function () {
        if ($(this).hasClass('is-invalid')) {
            validateEmailField(this);
        }
    });

    $(document).on('input', '.required-field:not(.phone-input):not(.email-input)', function () {
        if ($(this).hasClass('is-invalid')) {
            validateRequiredField(this);
        }
    });

    $(document).on('input', '#TermsCheck', function () {
        let termsCheckBox = $(this);

        if (termsCheckBox.length && !termsCheckBox.is(':checked')) {
            $('#acceptsTermsError').text(translations.termsNotAccepted);
        } else {
            $('#acceptsTermsError').text('');
        }
    })

    $(document).on('input', 'input[name="paymentMethod"]', function () {
        $('#invoiceDetails').removeClass('hidden');
        $('#paymentMethodError').text('');
    });

    $('#checkCampaignCodeInput')
        .on('input', _ => {
            window.campaignCodeValid = false;
        })
        .on('blur', _ => {
            validateCampaignCode();
        });

    $('#orderForm').submit(function (event) {
        event.preventDefault(); // Prevent form submission

        let isValid = true;
        let termsCheckBox = $('#TermsCheck')

        if (termsCheckBox.length && !termsCheckBox.is(':checked')) {
            $('#acceptsTermsError').text(translations.termsNotAccepted);
            isValid = false
        } else {
            $('#acceptsTermsError').text('');
        }

        if (!isFreeCourse && !$('input[name="paymentMethod"]:checked').length) {
            $('#paymentMethodError').text(translations.paymentMethodNotChosen);
            isValid = false;
        } else {
            $('#paymentMethodError').text('');
        }

        // Validate fields
        $('.phone-input').each(function () {
            if (!validatePhoneNumberField(this)) {
                isValid = false;
            }
        });

        $('.email-input').each(function () {
            if (!validateEmailField(this)) {
                isValid = false;
            }
        });

        $('.required-field:not(.phone-input):not(.email-input)').each(function () {
            if (!validateRequiredField(this)) {
                isValid = false;
            }
        });

        isValid = isValid && window.campaignCodeValid;

        if (isValid) {
            submitOrderForm(false);
        } else {
            console.log('Form validation failed.');
        }
    });

    //brreg search and autofill, debounce function to avoid spamming api calls
    $('#CompanyName').keyup(function () {
        debouncedSearch();
    });

    $('#companyResult').change(function () {
        var selectedCompanyName = $(this).val();
        $('#companyName').val(selectedCompanyName);
        $('#companyResult').css('display', 'none');

        $.get('https://data.brreg.no/enhetsregisteret/api/enheter?navn=' + selectedCompanyName, function (data) {
            if (data && data._embedded && data._embedded.enheter) {
                var selectedCompany = data._embedded.enheter[0];
                var addressInfo = selectedCompany.forretningsadresse;

                $('#CompanyName').val(selectedCompany.navn);
                $('#OrgNumber').val(selectedCompany.organisasjonsnummer);
                $('#AddressField').val(addressInfo.adresse?.[0]);
                $('#PostalArea').val(addressInfo.poststed);
                $('#PostalCode').val(addressInfo.postnummer);
            }
        });
    });

    $('#NewsletterCheck').on('change', function () {
        let newsletterCheckBox = $(this);
        let areasOfInterest = $('#AreasOfInterest');

        if (newsletterCheckBox.is(':checked')) {
            areasOfInterest.removeClass('hidden');
        } else {
            areasOfInterest.addClass('hidden');
        }
    });

    getCourseQuote();
    validateCampaignCode();

    setupPoppers();
});

function search() {
    let searchInput = document.getElementById('CompanyName').value;

    $.get('https://data.brreg.no/enhetsregisteret/api/enheter?navn=' + searchInput, function (data) {
        $('#companyResult').empty().css('display', 'block');

        if (data && data._embedded && data._embedded.enheter) {
            data._embedded.enheter.forEach(function (enhet) {
                $('#companyResult').append($('<option>', {
                    value: enhet.navn,
                    text: `${enhet.navn} - (${enhet.organisasjonsnummer})`
                }));
            });
        }
    });
}

function debounce(func, delay) {
    let timerId;
    return function (...args) {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

function validateCampaignCode() {
    let inputField = $('#checkCampaignCodeInput');
    let campaignCode = inputField.val();
    let labelContainer = $('.campaign-code .label-container');
    let messageContainer = labelContainer.children('.message-container');
    let deliveryId = $('#SelectedCourseDelivery').val();

    if (window.campaignCodeValid || !campaignCode) {
        // user removed the campaign code
        if (!window.campaignCodeValid) {
            getCourseQuote();
        }

        window.campaignCodeValid = true;
        messageContainer.remove();
        inputField.removeClass('is-invalid');
        return;
    }

    $.ajax({
        url: `/api/CheckCampaignCode?deliveryId=${deliveryId}&campaignCode=${encodeURIComponent(campaignCode)}`,
        type: 'GET',
        success: function (response) {
            messageContainer.remove();
            inputField.removeClass('is-invalid');

            window.campaignCodeValid = response.successful;
            if (response.successful) {
                let isValueDiscountType = response.campaign.discount_type === 'Value';
                let discountSuffix = isValueDiscountType ? ` ${response.campaign.currency.toUpperCase()}` : '%'
                $(`<span class="message-container success-message">${translations.validCampaignCode} ${response.campaign.discount_value}${discountSuffix}</span>`).appendTo(labelContainer);

                getCourseQuote(encodeURIComponent($('#checkCampaignCodeInput').val()));
            } else {
                $(`<span class="message-container error-message">${translations.invalidCode}</span>`).appendTo(labelContainer);
                inputField.addClass('is-invalid');

                getCourseQuote();
            }
        },
        error: function () {
            console.log('Error occurred while checking the campaign code.');
            $(`<span class="message-container error-message">${translations.invalidCode}</span>`).appendTo(labelContainer);
            window.campaignCodeValid = false;
            inputField.addClass('is-invalid');
        }
    })
}

function getCourseQuote(campaignCode) {
    let deliveryId = $('#SelectedCourseDelivery').val();
    let additionalProductsParams = typeof additionalProducts != "undefined" && additionalProducts.length > 0
        ? `&additionalProductIds=${additionalProducts.map(p => p.id).join(',')}` : '';
    let campaignCodeParam = campaignCode ? `&campaignCode=${campaignCode}` : '';

    if (!deliveryId) {
        return;
    }

    $.ajax({
        url: `/api/GetOrderQuote?deliveryId=${deliveryId}${campaignCodeParam}${additionalProductsParams}`,
        type: 'GET',
        headers: {
            'RequestVerificationToken': $('input[name="__RequestVerificationToken"]').val()
        },
        success: function (response) {
            window.unitPrice = response.quote.total_after_discounts_excl_vat;
            window.unitVat = response.quote.total_vat;
            window.totalDiscounts = response.quote.total_calculated_discounts;

            let noOfParticipants = parseInt($('#NumberOfParticipants').val());
            let totalPrice = window.unitPrice * noOfParticipants;
            let totalVat = window.unitVat * noOfParticipants;
            let totalPriceWithVat = totalPrice + totalVat;

            $('.unit-price').text(window.unitPrice.toLocaleString(document.documentElement.lang, {
                style: 'currency',
                currency: 'nok'
            }));
            $('#totalPrice').text(totalPrice.toLocaleString(document.documentElement.lang, {
                style: 'currency',
                currency: 'nok'
            }));
            $('#totalVat').text(totalVat.toLocaleString(document.documentElement.lang, {
                style: 'currency',
                currency: 'nok'
            }));
            $('#priceToPay').text(totalPriceWithVat.toLocaleString(document.documentElement.lang, {
                style: 'currency',
                currency: 'nok'
            }));
        },
        error: function (xhr, status, error, response) {
            console.error('Error occurred while getting course quote.', JSON.stringify(response));
        }
    });
}

function submitOrderForm() {
    let submitButton = $('#submitOrderFormBtn');

    submitButton.prop('disabled', true);
    submitButton.text(translations.sendingRegistration)

    let formData = getFormData();

    $.ajax({
        url: '/api/SubmitOrderForm',
        type: 'POST',
        headers: {
            'RequestVerificationToken': $('input[name="__RequestVerificationToken"]').val()
        },
        contentType: 'application/json',
        data: JSON.stringify(formData),
        success: function (response) {

            if (response.frontCoreResponse.data.summary.payment_details.requires_redirect) {
                window.location.href = response.frontCoreResponse.data.summary.payment_details.redirect_url; // Redirect to the specified URL
            } else {
                let loc = window.location;
                window.location.href = `${response.redirectUrl}?orderid=${response.frontCoreResponse.data.summary.order_id}`;
            }
        },
        error: function (xhr, status, error, response) {

            submitButton.prop('disabled', false);
            submitButton.text(translations.sendRegistration)
        }
    });
}

function getFormData() {
    let paymentMethod = $('input[name="paymentMethod"]:checked').val() || (isFreeCourse ? 'invoice' : null);
    let newsletterCheckBoxChecked = $('#NewsletterCheck').is(':checked');
    let formData = {
        CoursePageId: $('#CoursePageId').val(),
        CoursePageLang: $('#CoursePageLang').val(),
        CourseDeliveryId: $('#SelectedCourseDelivery').val(),
        BookerName: $('#OrdererName').val(),
        BookerPhoneNumber: $('#OrdererPhoneNumber').val().replace(/\s/g, ''),
        BookerEmail: $('#OrdererEmail').val(),
        CompanyName: $('#CompanyName').val(),
        CampaignCode: $('#checkCampaignCodeInput').val(),
        // VoucherCode: $('#checkVoucherCodeInput').val(),
        Participants: [],
        PaymentMethod: paymentMethod,
        AcceptsTerms: $('#TermsCheck').is(':checked'),
        WantsNewsletter: newsletterCheckBoxChecked,
        AreasOfInterest: newsletterCheckBoxChecked ? $('#AreasOfInterest input:checked').map((_, el) => el.value).get() : []
    }

    $('div[id^="participant-"]').each(function (index) {
        formData.Participants[index] = {
            FirstName: $(`#Participants_${index}__FirstName`).val(),
            LastName: $(`#Participants_${index}__LastName`).val(),
            Email: $(`#Participants_${index}__Email`).val(),
            PhoneNumber: $(`#Participants_${index}__PhoneNumber`).val(),
            Comment: $(`#Participants_${index}__Comment`).val(),
            Products: additionalProducts?.map(p => p.id)
        };
    });

    if (!isFreeCourse) {
        formData.Invoice = {
            OrgNumber: $('#OrgNumber').val(),
            Address: $('#AddressField').val(),
            PostalCode: $('#PostalCode').val(),
            PostalArea: $('#PostalArea').val(),
            Email: $('#InvoiceEmail').val(),
            Reference: $('#InvoiceReference').val(),
            Ehf: $('#InvoiceEhf').val()
        };
    }

    return formData;
}

function setupPoppers() {
    const buttons = document.querySelectorAll('.tooltip-button');

    for (let button of buttons) {
        const tooltip = button.nextElementSibling;

        const popperInstance = createPopper(button, tooltip, {
            placement: 'top',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 8],
                    }
                }
            ]
        });

        button.addEventListener('click', (e) => {
            e.preventDefault();

            tooltip.toggleAttribute('data-show');
            popperInstance.update();
        });

        document.addEventListener('click', (e) => {
            if (!button.contains(e.target) && !tooltip.contains(e.target)) {
                tooltip.removeAttribute('data-show');
            }
        });
    }
}